import styled from 'styled-components';
import { PageHeader } from 'ui/pageHeader';
import { ChevronDown } from 'ui/icons/navigation/ChevronDown';
import { body1, body2, caption, colors, heading3, heading4, spacing, zIndex } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p40: pxToRem(40),
  p80: pxToRem(80),
  p200: pxToRem(200),
};

export const StyledPageHeader = styled(PageHeader)`
  margin: 0;
  padding: ${spacing.double} 0 ${spacing.plusHalf} 0;
`;

export const StyledHeader = styled.div`
  ${heading3};
  margin: ${spacing.double} 0;
`;

export const HeaderSubSectionWrapper = styled.div`
  ${caption};
  margin-top: ${spacing.half};
  color: ${colors.textSecondary};
`;

export const TimeRangeHeaderWrapper = styled.div`
  ${body1};
  width: 100%;
  margin: ${customSpacing.p40} 0;
  padding: ${spacing.base} ${spacing.plusHalf};
  background: ${colors.purple100};
  color: ${colors.white};
  border-radius: ${spacing.threeEights};
`;

export const DatePickerContainer = styled.div`
  display: inline-block;
  padding-left: ${spacing.half};
`;

export const DatePickerTriggerButton = styled.button`
  ${body2}
  height: ${pxToRem(42)};
  width: 100%;
  align-items: center;
  color: ${colors.textPrimary};
  display: flex;
  flex: 1 1 auto;
  border: none;
  justify-content: space-between;
  outline: none;

  && {
    border: solid ${spacing.single} ${colors.grey15};
  }
  :focus {
    border-color: ${colors.purple50};
    box-shadow: 0 0 0 ${spacing.single} ${colors.purple50};
  }
  :hover {
    border-color: ${colors.purple50};
  }
  padding: ${spacing.threeQuarter} ${spacing.base};
  border-radius: ${spacing.quarter};
  background: ${colors.white};
`;

export const DatePickerWrapper = styled.div`
  position: absolute;
  z-index: ${zIndex.dropdown};
  background-color: ${colors.white};
  color: ${colors.textPrimary};
  border-radius: ${spacing.half};
`;

export const StyledChevronDown = styled(ChevronDown)`
  margin-left: ${spacing.half};
`;

export const SectionHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${customSpacing.p40};
`;

export const StyledSectionTitle = styled.div`
  ${heading4};
`;

export const SectionSubTitle = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;

export const DisplayCenterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const NoDataContainer = styled(DisplayCenterWrapper)`
  margin: ${customSpacing.p80} 0 ${customSpacing.p200};
`;

export const NoDataTitle = styled.span`
  ${heading4}
  margin-top: ${spacing.half};
`;

export const NoDataSubTitle = styled.span`
  ${body1}
  color: ${colors.textSecondary};
  margin-top: ${spacing.half};
  max-width: ${spacing.x40};
  text-align: center;
`;

export const ErrorStateContainer = styled(DisplayCenterWrapper)`
  height: 100%;
`;

export const ErrorStateTitle = styled.span`
  ${heading4}
  margin-top: ${spacing.plusHalf};
`;

export const ErrorSubTitle = styled.a`
  ${body1}
  color: ${colors.textSecondary};
  margin-top: ${spacing.half};
  text-decoration-line: underline;
`;
